import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { BrwoseFilesComponent } from '../brwose-files/brwose-files.component';
import { MapfreModalComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ModalOptions, AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, BrwoseFilesComponent, MapfreButtonComponent],
  selector: 'app-uploading-files-modal',
  templateUrl: './uploading-files-modal.component.html',
  styleUrls: ['./uploading-files-modal.component.scss'],
})
export class UploadingFilesModalComponent implements OnInit {
  @Input() uploadedFile: string;
  @Input() selectedFileData: any;
  @Input() invalidFileType: string;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter();
  @Output() uploadFileEvent: EventEmitter<any> = new EventEmitter();
  documentType = '';
  uploadingFiles: ModalOptions;
  hideModal: boolean;
  isAcmic: boolean;
  hideModalOnRoute: any = false;
  constructor(private acmicService: AcmicService) {
    this.hideModal = false;
    this.uploadingFiles = new ModalOptions({
      additionalClasses:
        'modal-medium modal-dialog center-on-page confirm-modal modal-dialog-scrollable',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'uploadingFileModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      modalTranslateCopy: this.acmicService.isACMIC() ? 'Uploading file' : '',
      modalName: 'uploading_files',
    });
  }
  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
  }
  resetHideModal(event): void {
    this.hideModal = !this.hideModal;
    if (event) {
      this.closeModal.emit(true);
    }
  }

  saveUploadFile() {
    this.uploadFileEvent.emit(this.documentType);
    this.resetHideModal('');
  }

  onClickBack() {
    this.resetHideModal(true);
  }
}
